module.exports = __webpack_public_path__ + "static/media/weights bike doggo.f5801197.svg";